// §VI board data — the VARIANTS from the Claude Design canon `R10 - §VI - canon F5`
// (project dd7b95d4, data-canon="R10-§VI-F5"), transcribed verbatim: the data section of the
// canon page script (stages, stack quotes, quote_n, reason states) is reproduced here
// unchanged — same helper shape (mk / Q / NO / boundary) that CD authored.
//
// F4 = SILENT SKIP (D&R s414.d2, over s280): F3's visible absence states are reversed. A stage
// without a quote is dropped BEFORE layout (no card, no line, no trace); a silent quote_n
// renders nothing; N_quotes < 2 removes the section and renumbers the document. The reason
// codes still ride in the data (v04's stack is all-reason) so SectionVI can derive the
// degradation branch, but nothing about them prints. F5 (s882.d1) removes the last printable
// absence state — the doc-level transport_failed board v03 is deleted; a transport failure now
// collapses to the same N < 2 removal. Content is the System 2 engine's output. Detector /
// System 2 is not touched here.
//
// 8 board-views → 9 artboards: every board renders one sheet except v08 (N=15) which the
// real-browser fit splits across two sheets. §VI paginates by MEASURED height, which jsdom
// cannot do — so the split (`sheets[i].take`) and the fit tier per sheet are BAKED here from
// the real-browser capture (see scripts/capture-svg-golden-vi.mjs). Numbering + denom are
// deterministic (recomputed in SectionVI after filtering reason cards). v03 is intentionally
// absent — the number is not reused (parity matches by label, not index).

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV'];

// ---- canon data helpers (verbatim from the canon page script) ----
const S01 = ['before', 'the first year', 'the mirror year', 'everything for them', 'still here'];
const S07 = ['the early years', 'the long flat middle', 'the year they left', 'past the point of sense', 'still married'];
const mk = (names) => names.map((n, i) => ({ name: n, roman: ROMAN[i], current: i === names.length - 1 }));
const Q = (stage, field, text) => ({ stage, field, text, reason: null });
const NO = (stage, reason) => ({ stage, field: null, text: '', reason });

const B01 = [
  Q(0, 'T3', "wouldn't let myself admit I was scared of losing me"),
  Q(1, 'T3', "didn't let myself miss the person I used to be"),
  Q(2, 'T3', "wouldn't allow myself a single hour that wasn't for someone else"),
  Q(3, 'T3', "didn't let myself want anything just for me")];
const QN01 = Q(4, 'T3', 'I stopped asking when I get to come back to myself');
const cl = (a) => a.map((o) => ({ ...o }));

// ---- baked real-browser fit (captured from canon F4, re-verified byte-identical on F5 —
//      s882.d1 removed only the transport board, pagination unchanged; jsdom mis-splits) ----
const T = 'ev-fit-tight';
const TSF = 'ev-fit-tight ev-fit-smaller ev-fit-floor';

const V = [];
// 01 · базовый
V.push({ id: 'v01', screen: '§VI · 01 · базовый', source: '01-singleton.json', stages: mk(S01),
  stack: cl(B01), qn: { ...QN01 }, sheets: [{ take: 4, cls: '', note: '' }] });
// 02 · капы (рез не сработал)
V.push({ id: 'v02', screen: '§VI · 02 · длинные цитаты · капы', source: '07-long.json', stages: mk(S07),
  stack: [
    Q(0, 'T2', 'the thing between us had quietly stopped being love a long time before either of us was willing to say it out loud'),
    Q(1, 'T2', 'kept telling myself the comfort was the same as contentment'),
    Q(2, 'T2', 'knew the only thing still holding the marriage upright was the sheer weight of how long it had already lasted, and told myself that weight was the same thing as a foundation'),
    Q(3, 'T2', 'kept it going out of loyalty to the years, not the man')],
  qn: Q(4, 'T2', 'I tell everyone we are fine and it is the truest lie I have'),
  sheets: [{ take: 4, cls: '', note: '' }] });
// 02a · подрезка сработала
V.push({ id: 'v02a', screen: '§VI · 02a · подрезка сработала', source: '07-long.json · сырые T-поля', synthetic: true, stages: mk(S07),
  stack: [
    Q(0, 'T2', 'I knew somewhere underneath all the routines and the shared calendars and the way we still said we love you out of habit that the thing between us had quietly stopped being love a long time before either of us was willing to say it out loud'),
    Q(1, 'T2', 'kept telling myself the comfort was the same as contentment'),
    Q(2, 'T1', 'the year the children left and the house got loud with everything we were no longer saying to each other across a kitchen that had never once, in twenty-two years, felt as empty as it did with just the two of us finally alone in it'),
    Q(3, 'T2', 'kept it going out of loyalty to the years, not the man')],
  qn: Q(4, 'T3', "I stopped asking myself whether staying this long has been devotion or just fear wearing devotion's coat, because I am genuinely no longer sure there is a difference left to find at this point in a life this far along, and I am not sure I want to know which one it was"),
  sheets: [{ take: 4, cls: '', note: '' }] });
// 03 · СНЯТ по s882.d1 (transport_failed артборд удалён из канона F5). Номер НЕ переиспользуется:
// парити матчит артборды по label, не по сквозному индексу; ряд идёт 01 · 02 · 02a · 04 · … и
// пропуск намеренный (решение CC 22.09, CD подтвердил, эталоны держат имена).
// 04 · все цитаты отсутствуют → раздел удалён + перенумерация (тихий скип, печатной копи нет)
V.push({ id: 'v04', screen: '§VI · 04 · все цитаты отсутствуют', source: '08-empty.json', stages: mk(S01),
  stack: [NO(0, 'empty'), NO(1, 'llm_declined'), NO(2, 'empty'), NO(3, 'empty')], qn: NO(4, 'empty') });
// граничные N
const S15 = ['the first room', 'the borrowed years', 'after the move', 'the long apprenticeship', 'the good stretch', 'the first crack', 'the year of holding on', 'the collapse', 'the quiet after', 'starting over', 'the second climb', 'the year of the offer', 'saying no out loud', 'the smaller life', 'still going'];
const Q15 = [
  'said yes to the room because it was cheap and told myself that was the same as choosing it',
  'kept the ledger in my head and never once said the number out loud',
  'knew the move was his idea and called it ours for four more years',
  "wouldn't let myself count how many evenings I gave to a craft nobody asked me to master",
  'stopped waiting for the good stretch to end and it ended anyway',
  'knew the crack was structural and kept patching the paint',
  'held it up alone and called that competence',
  'let it go down without telling anyone it was going',
  "didn't allow myself to enjoy how quiet it was",
  'started again in a smaller room and did not tell it to anyone',
  'wanted the climb more than I wanted to be seen doing it',
  'knew the offer was flattery dressed as opportunity and took the meeting anyway',
  "didn't let myself feel relieved when I turned it down",
  'kept the smaller life a secret from the people who knew the bigger one',
  'I tell people the second climb is easier and I have never once checked whether that is true'];
// ACCEPTED-DEBT (s447): T4 «who was around» снят из контракта (s443.d1/s452.d1) — движок
// больше НЕ эмитит field:'T4', в живом паспорте T4-карточек не существует. Здесь T4 оставлен
// НАМЕРЕННО: этот FSEQ метит СИНТЕТИЧЕСКИЕ N-count стресс-борды v06–v08 (field·who was around),
// приколотые к замороженному CD-golden (cd-svg-section-vi.json = браузер-захват канона F5).
// F5 (s882.d1) НЕ снял T4 из синтетики — CD оставил FSEQ ради byte-parity борда, так что долг
// стоит и на F5. Дроп T4 здесь сломал бы svg-parity-vi, пока CD не переиздаст §VI с новым FSEQ +
// не переснимет golden. Подтянуть в следующий раз, когда CD и так тронет §VI (или в downstream
// «дырявая персона»).
const FSEQ = ['T1', 'T2', 'T3', 'T4'];
function boundary(id, N, sheets) {
  const names = N === 2 ? ['before', 'still here'] : S15.slice(0, N - 1).concat([S15[14]]);
  const texts = N === 2 ? [Q15[0], Q15[14]] : Q15.slice(0, N - 1).concat([Q15[14]]);
  return { id, screen: `§VI · ${id.slice(1)} · N = ${N}`, source: 'synthetic', synthetic: true, stages: mk(names),
    stack: texts.slice(0, N - 1).map((t, i) => Q(i, FSEQ[i % 4], t)),
    qn: Q(N - 1, 'T2', texts[N - 1]), sheets };
}
V.push(boundary('v05', 2, [{ take: 1, cls: '', note: '' }]));
V.push(boundary('v06', 8, [{ take: 7, cls: T, note: 'плотный шаг стопки' }]));
V.push(boundary('v07', 9, [{ take: 8, cls: T, note: 'плотный шаг стопки' }]));
V.push(boundary('v08', 15, [
  { take: 11, cls: TSF, note: 'плотный шаг стопки · цитаты 22 → 20px, крупная 36 → 32px · цитаты 20 → 19px — пол кегля, ниже не идём · хвост 3 карточки перенесён на следующий лист' },
  { take: 3, cls: '', note: '' },
]));

export const VI_BOARDS = V;
export const VI_PARITY_BOARDS = VI_BOARDS.filter((b) => b.parity !== false);
